import React, { lazy } from 'react';
import { useGeoPricing } from '../hooks/useGeoPricing';
import { OfferBox } from './OfferBox';
import { CTAButton } from './CTAButton';
const placeholderImg = 'https://digitalearnpro.com/wp-content/uploads/2025/09/20250930_1424_Espacio-para-tu-Imagen_simple_compose_01k6dtcpvgec9s48a98jsekbnr.png';
const detoxImg = 'https://cdn.magicpatterns.com/uploads/vb1nUkmkB4egmxspPoNHzH/Gemini_Generated_Image_z7ccufz7ccufz7cc.jpg';
const calendarioImg = 'https://cdn.magicpatterns.com/uploads/kby5okDKHbz9RL8n8bsZbm/Gemini_Generated_Image_fmetdrfmetdrfmet.jpg';
const snacksImg = 'https://cdn.magicpatterns.com/uploads/nDs74nNuJ1xmdQkJwAoGJp/Gemini_Generated_Image_19fmz119fmz119fm.jpg';
const listaImg = 'https://cdn.magicpatterns.com/uploads/hzChyjUYzM8oowG9jjuqMS/Gemini_Generated_Image_s700n5s700n5s700.jpg';
const batidosImg = 'https://cdn.magicpatterns.com/uploads/f66Nicfe8NrQfxoXW3NsJR/Gemini_Generated_Image_l2k1mbl2k1mbl2k1.jpg';
const bonuses = [{
  name: 'Guía de Lista de la Compra Inteligente',
  img: listaImg
}, {
  name: 'Planificador Semanal Imprimible',
  img: calendarioImg
}, {
  name: 'Guía de Suplementación Básica',
  img: detoxImg
}, {
  name: 'Comunidad Exclusiva / Soporte',
  img: batidosImg
}, {
  name: 'Guía de Cenas Express',
  img: snacksImg
}];
export function BonusSection() {
  const {
    pricing
  } = useGeoPricing();
  return <section className="bg-cream pt-[40px] pb-[40px] px-[15px] relative" data-id="element-15">
      <div className="max-w-[700px] mx-auto px-[15px] text-center" data-id="element-16">
        <h2 className="text-[26px] mb-6 leading-[1.2] font-bold text-black heading-underline" data-id="element-17">
          🎁 Con tu compra de{' '}
          <strong data-id="element-18">
            <u data-id="element-19">HOY</u>
          </strong>
          , te llevas{' '}
          <strong data-id="element-20">
            <u data-id="element-21">5 BONUS Exclusivos</u>
          </strong>{' '}
          GRATIS
        </h2>
        <p className="text-dark-gray text-[15px] leading-[1.6]" data-id="element-22">
          Herramientas extra para <strong data-id="element-23">garantizar tu éxito</strong> en la
          cocina ✨
        </p>
      </div>

      <div className="max-w-[700px] mx-auto px-[15px]" data-id="element-24">
        <div className="grid grid-cols-[repeat(auto-fill,minmax(140px,1fr))] gap-[15px] mt-[30px]" data-id="element-25">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-white border border-[#eee] rounded-lg p-3 text-center transition-all duration-400 ease-[cubic-bezier(0.25,0.8,0.25,1)] shadow-[0_4px_10px_rgba(0,0,0,0.05)] flex flex-col hover:-translate-y-1.5 hover:shadow-[0_8px_20px_rgba(0,0,0,0.08)] relative overflow-hidden" data-id="element-26">
              <div className="absolute top-2 right-2 bg-red-600 text-white text-[10px] font-extrabold px-2 py-1 rounded-full z-10 shadow-md animate-pulse" data-id="element-27">
                ¡GRATIS HOY!
              </div>
              <img loading="lazy" alt={bonus.name} src={bonus.img} className="w-full h-auto rounded mb-3" data-id="element-28" />
              <h3 className="text-[14px] font-semibold text-black leading-[1.4] m-0 mb-2 grow" data-id="element-29">
                🎁 {bonus.name}
              </h3>
              <div className="text-[12px] font-normal mt-auto pt-2 border-t border-[#eee] leading-[1.3]" data-id="element-30">
                Valorado en:{' '}
                <span className="inline-block mr-1.5 text-gray line-through" data-id="element-31">
                  <strong data-id="element-32">{pricing.bonusPrice}</strong>
                </span>
                <span className="inline-block text-success font-bold mt-1 block" data-id="element-33">
                  <strong data-id="element-34">HOY GRATIS</strong>
                </span>
              </div>
            </div>)}
        </div>

        <div className="text-center my-[40px] mx-auto p-6 rounded-xl bg-white shadow-[0_4px_10px_rgba(0,0,0,0.05)] max-w-[400px] border border-[#eee]" data-id="element-35">
          <div className="text-[24px] text-black mb-3 font-bold" data-id="element-36">
            ¡Y MÁS REGALOS SORPRESA!
          </div>
          <p className="text-dark-gray text-[15px] leading-[1.6] mb-1" data-id="element-37">
            Valor total del pack:
          </p>
          <div className="text-[28px] font-bold line-through text-danger mb-1" data-id="element-38">
            87€
          </div>
          <div className="text-[15px] text-dark-gray mb-3" data-id="element-39">
            Hoy solo:{' '}
            <span className="text-success font-extrabold text-[22px]" data-id="element-40">
              12.99€
            </span>
          </div>
          <div className="text-[32px] font-extrabold text-success uppercase" data-id="element-41">
            <span className="font-normal text-[18px] block text-dark-gray normal-case mb-1" data-id="element-42">
              5 Bonus valorados en 32.50€:
            </span>
            ¡GRATIS!
          </div>
        </div>

        <div className="max-w-[500px] mx-auto" data-id="element-43">
          <div className="my-6 mx-auto overflow-hidden shadow-[0_8px_20px_rgba(0,0,0,0.08)] rounded-lg relative max-w-full" data-id="element-44">
            <img loading="lazy" alt="Pack Completo de Recetas Saludables" src="https://cdn.magicpatterns.com/uploads/bpVu2AsHVShDvznTxhtj16/Gemini_Generated_Image_a8prx6a8prx6a8pr.jpg" className="w-full h-auto block rounded-lg" data-id="element-45" />
          </div>

          <div className="text-center my-[30px] mx-auto mb-[20px]" data-id="element-46">
            <p className="text-[11px] font-semibold text-gray tracking-[1px] uppercase mb-2" data-id="element-47">
              +5.820 DESCARGAS
            </p>
            <h1 className="text-[18px] font-bold leading-[1.4] text-black" data-id="element-48">
              📦 Pack de Recetas Personalizadas + 5 Bonus Exclusivos 🎁
            </h1>
          </div>

          <OfferBox data-id="element-49" />

          <CTAButton href="https://kleoyshop.com/cart/add?id=52708878745928&quantity=1" className="max-w-[500px] mt-6" data-id="element-50">
            ¡Quiero mi Pack con Descuento!
          </CTAButton>
        </div>
      </div>
    </section>;
}